<template>
  <div>
    
    <main>
      <h1>Garage Vehicle List</h1>
      <table>
        <thead>
          <tr>
            <th>License Plate</th>
            <th>Model</th>
            <th>Make</th>
            <th>Year</th>
            <th>Status</th>
          </tr>
        </thead>

        <!-- Error Message -->
        <div v-if="errorMessage" class="error">
          {{ errorMessage }}
        </div>

        <tbody>
          <tr v-for="(vehicle, index) in vehicles" :key="index">
            <td>{{ vehicle.licensePlate }}</td>
            <td>{{ vehicle.model }}</td>
            <td>{{ vehicle.make }}</td>
            <td>{{ vehicle.year }}</td>
            <td>
              <span
                :style="vehicle.status === 'Serviced' ? servicedStyle : pendingStyle"
                @click="handleStatusClick(vehicle.status)"
              >
                {{ vehicle.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </main>
  </div>
</template>

<script>
export default {
  name: 'VehicleList',
  data() {
    return {
      errorMessage: '',
      vehicles: [
        { licensePlate: 'T200 SAS', model: 'HARRIER', make: 'TOYOTA', year: 2009, status: 'Pending' },
        { licensePlate: 'T200 SAS', model: 'HARRIER', make: 'TOYOTA', year: 2009, status: 'Serviced' },
        { licensePlate: 'T200 SAS', model: 'HARRIER', make: 'TOYOTA', year: 2009, status: 'Serviced' },
        { licensePlate: 'T200 SAS', model: 'HARRIER', make: 'TOYOTA', year: 2009, status: 'Pending' },
        { licensePlate: 'T200 SAS', model: 'HARRIER', make: 'TOYOTA', year: 2009, status: 'Serviced' },
        { licensePlate: 'T200 SAS', model: 'HARRIER', make: 'TOYOTA', year: 2009, status: 'Serviced' },
        { licensePlate: 'T200 SAS', model: 'HARRIER', make: 'TOYOTA', year: 2009, status: 'Pending' },
        { licensePlate: 'T200 SAS', model: 'HARRIER', make: 'TOYOTA', year: 2009, status: 'Serviced' },
        { licensePlate: 'T200 SAS', model: 'HARRIER', make: 'TOYOTA', year: 2009, status: 'Serviced' }
      ],
    };
  },
  methods: {
    handleStatusClick(status) {
      if (status === 'Pending') {
        alert('Unsuccessful served');
      } else if (status === 'Serviced') {
        alert('Successful served');
      }
    }
  },
  computed: {
    servicedStyle() {
      return {
        backgroundColor: '#4efdec',
        color: 'black',
        padding: '5px 10px',
        borderRadius: '4px',
        cursor: 'pointer',
      };
    },
    pendingStyle() {
      return {
        backgroundColor: 'black',
        color: 'white',
        padding: '5px 10px',
        borderRadius: '4px',
        cursor: 'pointer',
      };
    }
  }
};
</script>

<style scoped>
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  color: #333;
}
h1 {
  text-align: center;
}
main {
  padding: 100px;
  text-align: center;
  justify-content: center;
}
table {
  width: 90%;
  border-collapse: collapse;
  margin: 20px auto;
}
table, th, td {
  border: 2px solid #4efdec;
}
th {
  background-color: #f4f4f4;
}
th, td {
  padding: 15px;
  text-align: left;
}
.error {
  color: red;
  margin-top: 10px;
}
</style>
